import DeleteResourceInteractor from "../../core/interactor/app/crud/DeleteResourceInteractor";
import Constants from "../common/Constants";

export default class RemoveOrganisationIndexGroupInteractor {
  private resource: DeleteResourceInteractor;

  constructor({ deleteResource }) {
    this.resource = deleteResource;
  }

  execute(organisationId: number, groupId: number) {
    return this.resource.execute(
      `${Constants.organisationsPath}/${organisationId}/groups`,
      groupId
    );
  }
}
